<template>
    <div class="participationRate" :id="Id"></div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['InjectData', 'Id'],
    data() {
        return {

        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {
        InjectData: {
            handler() {
                // this.participation_graphics()
                this.Proportion();
            },
            deep: true,
        }
    },

    // 方法集合
    methods: {
        calculateAverage(key) {
            if (!this.InjectData || this.InjectData.length === 0) return 0;
            const sum = this.InjectData.reduce((acc, item) => acc + parseFloat(item[key] || 0), 0);
            return sum / this.InjectData.length;
        },
        Proportion(data) {
            console.log('InjectData', this.InjectData);

            let that = this;
            this.$echarts.init(document.getElementById(this.Id)).dispose();
            let myChart = this.$echarts.init(document.getElementById(this.Id));

            // 计算各指标的平均值
            const avgLevel34Rate = this.calculateAverage('level34Rate');
            const avgLevel234Rate = this.calculateAverage('level234Rate');
            const avgLevel1Rate = this.calculateAverage('level1Rate');

            myChart.setOption({
                dataZoom: [
                    {
                        type: 'inside',
                        startValue: 0,
                        endValue: 100,
                    }
                ],
                legend: {
                    show: true,
                    bottom: '3%',
                    left: 'center',
                    formatter: function (name) {
                        const suffixMap = {
                            'level34Rate': '优良率',
                            'level234Rate': '合格率',
                            'level1Rate': '待提升'
                        };
                        return (suffixMap[name] || '');
                    },
                },
                grid: {
                    top: '10%',
                    left: '5%',
                    right: '15%',
                    bottom: '15%',
                    containLabel: true
                },
                dataset: {
                    dimensions: ['name', 'level34Rate', 'level234Rate', 'level1Rate'],
                    source: that.InjectData
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        formatter: function (value) {
                            return value.includes('前测卷') ? '测评卷一' :
                                value.includes('后测卷') ? '测评卷二' :
                                    value;
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: function (value) {
                            return value + '%';
                        }
                    },
                    // 可选：添加更明显的网格线
                    splitLine: {
                        lineStyle: {
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: 'level34Rate',
                        type: 'bar',
                        encode: { y: 'level34Rate' },
                        barWidth: 30,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                            color: '#5470c6' // 为每个系列设置颜色
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                            formatter: function (params) {
                                return params.value['level34Rate'] + '%';
                            }
                        },
                        markLine: {
                            silent: true, // 不触发鼠标事件
                            symbol: 'none',
                            lineStyle: {
                                color: '#ff4d4f',
                                type: 'dashed',
                                width: 1
                            },
                            label: {
                                show: true,
                                position: 'end',
                                formatter: `优良平均: ${avgLevel34Rate.toFixed(1)}%`,
                                color: '#ff4d4f',
                                backgroundColor: 'rgba(255,255,255,0.8)',
                                padding: [2, 4]
                            },
                            data: [{
                                name: '优良率平均水平线',
                                yAxis: avgLevel34Rate,
                            }]
                        }
                    },
                    {
                        name: 'level234Rate',
                        type: 'bar',
                        barWidth: 30,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                            color: '#91cc75'
                        },
                        encode: { y: 'level234Rate' },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                            formatter: function (params) {
                                return params.value['level234Rate'] + '%';
                            }
                        },
                        markLine: {
                            silent: true,
                            symbol: 'none',
                            lineStyle: {
                                color: '#faad14',
                                type: 'dashed',
                                width: 1
                            },
                            label: {
                                show: true,
                                position: 'end',
                                formatter: `合格平均: ${avgLevel234Rate.toFixed(1)}%`,
                                color: '#faad14',
                                backgroundColor: 'rgba(255,255,255,0.8)',
                                padding: [2, 4]
                            },
                            data: [{
                                name: '合格率平均水平线',
                                yAxis: avgLevel234Rate,
                            }]
                        }
                    },
                    {
                        name: 'level1Rate',
                        type: 'bar',
                        barWidth: 30,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                            color: '#fac858'
                        },
                        encode: { y: 'level1Rate' },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                            formatter: function (params) {
                                return params.value['level1Rate'] + '%';
                            }
                        },
                        markLine: {
                            silent: true,
                            symbol: 'none',
                            lineStyle: {
                                color: '#52c41a',
                                type: 'dashed',
                                width: 1
                            },
                            label: {
                                show: true,
                                position: 'end',
                                formatter: `待提升平均: ${avgLevel1Rate.toFixed(1)}%`,
                                color: '#52c41a',
                                backgroundColor: 'rgba(255,255,255,0.8)',
                                padding: [2, 4]
                            },
                            data: [{
                                name: '待提升率平均水平线',
                                yAxis: avgLevel1Rate,
                            }]
                        }
                    },
                ]
            })
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        // this.Proportion();
    },
}
</script>
<style scoped lang="less">
.participationRate {
    width: 100%;
    height: 100%;
}
</style>